import { api } from '..';
import { PricingSheetItem } from '../../../shared/types/pricingSheetItems';
import { RentalHistorySourceType } from '../../../shared/types/pricingSheets';

/**
 * GET RENTAL HISTORY BY CUSTOMER ID
 */
export const getRentalHistoryById = async (
  customerId: string,
  startDate: string,
  endDate: string,
): Promise<any> => {
  const { data } = await api.get<any>(
    `/rental-history?customerId=${customerId}&rentalHistoryFrom=${startDate}&rentalHistoryTo=${endDate}`,
    { timeout: 1200000 },
  );
  return data;
};

/**
 * GET RENTAL HISTORY BY CUSTOMER ID JOB
 */
export const getRentalHistoryByIdUsingJob = async (
  customerId: string,
  startDate: string,
  endDate: string,
): Promise<any> => {
  const { data } = await api.get<any>(
    `/rental-history/job?customerId=${customerId}&rentalHistoryFrom=${startDate}&rentalHistoryTo=${endDate}`,
    { timeout: 1200000 },
  );
  return data;
};

/**
 * GET RENTAL HISTORY BY COMPANY CHAIN ID
 */
export const getRentalHistoryByCompanyChainId = async (
  companyChainId: string,
  startDate: string,
  endDate: string,
): Promise<any> => {
  const { data } = await api.get<any>(
    `/rental-history/company-chain?companyChainId=${companyChainId}&rentalHistoryFrom=${startDate}&rentalHistoryTo=${endDate}`,
  );
  return data;
};

type RentalHistoryRequestBody = {
  rentalHistoryCustomerId: string;
  rentalHistoryCustomerName: string;
  rentalHistoryStartDate: Date;
  rentalHistoryEndDate: Date;
  rentalHistoryCompanyChainId: string;
  rentalHistorySourceType: RentalHistorySourceType;
  rentalHistoryCompanyName: string;
};

/**
 * UPDATE RENTAL HISTORY PRICING SHEET
 */
export const updateRentalHistoryPricingSheet = async (
  pricingSheetId: string,
  pricingSheet: RentalHistoryRequestBody,
  pricingSheetItems: PricingSheetItem[],
): Promise<any> => {
  const { data } = await api.put<any>(
    `/rental-history/${pricingSheetId}`,
    {
      pricingSheet,
      pricingSheetItems,
    },
  );
  return data;
};
